import { Directive, HostListener, Input, Optional } from "@angular/core";
import { InputValidatorUtils } from "../utils/input-validator-utils";
import { NgControl } from "@angular/forms";

@Directive({
  selector: '[appInputValidator]'
})
export class InputValidatorDirective {
  @Input() allowNumbersOnly = false;
  @Input() allowAlphabetsOnly = false;
  @Input() sanitizeScriptTags = false;
  @Input() hasAtLeastOneAlphabet = false;

  constructor(@Optional() private readonly ngControl: NgControl) {}

  @HostListener('input', ['$event']) onInputChange(event: InputEvent) {
    const input = event.target as HTMLInputElement;
    let value = input.value;

    if (this.allowNumbersOnly) {
      value = InputValidatorUtils.onlyNumbers(value);
    }

    if (this.allowAlphabetsOnly) {
      value = InputValidatorUtils.onlyAlphabets(value);
    }

    if (this.sanitizeScriptTags) {
      value = InputValidatorUtils.removeScriptTags(value);
    }

    input.value = value;

    // ❗ Set custom validation error for no alphabet
    if (this.hasAtLeastOneAlphabet && this.ngControl?.control) {
      const hasAlphabet = InputValidatorUtils.hasAtLeastOneAlphabet(value);

      if (!hasAlphabet) {
        this.ngControl.control.setErrors({
          ...(this.ngControl.control.errors || {}),
          noAlphabet: true
        });
      } else {
        const errors = { ...(this.ngControl.control.errors || {}) };
        delete errors.noAlphabet;
        if (Object.keys(errors).length === 0) {
          this.ngControl.control.setErrors(null);
        } else {
          this.ngControl.control.setErrors(errors);
        }
      }
    }
  }
}